import React from "react";

// Default (new format)
export const defaultAssessmentData = [
  {
    category: "Health & Safety practices",
    details: "",
  },
  {
    category: "Working conditions",
    details: "",
  },
];

const AssessmentTable = ({ assessmentData = {}, setAssessmentData }) => {
  // Normalize to new array format if needed
  const normalizedData = Array.isArray(assessmentData)
    ? assessmentData
    : ["Health & Safety practices", "Working conditions"].map((category) => ({
        category,
        details: assessmentData[category] || "",
      }));

  const handleChange = (index, value) => {
    const updated = [...normalizedData];
    updated[index].details = value;
    setAssessmentData(updated);
  };

  return (
    <div
      style={{
        marginTop: "20px",
        overflowX: "auto",
        borderRadius: "8px",
        overflow: "hidden",
        border: "1px solid #000",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th style={headerStyle}> </th>
            <th style={headerStyle}>
              % of your plants and offices that were assessed <br />
              (by entity or statutory authorities or third parties)
            </th>
          </tr>
        </thead>
        <tbody>
          {normalizedData.map((row, index) => (
            <tr key={row.category}>
              <td style={labelStyle}>{row.category}</td>
              <td style={cellStyle}>
                <textarea
                  value={row.details}
                  onChange={(e) => handleChange(index, e.target.value)}
                  placeholder="Details"
                  style={textareaStyle}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Styles
const headerStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const labelStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "left",
  backgroundColor: "#F0E9EC",
  fontWeight: "bold",
};

const cellStyle = {
  padding: "10px",
  border: "1px solid #000",
};

const textareaStyle = {
  width: "100%",
  height: "60px",
  padding: "6px",
  borderRadius: "4px",
  border: "1px solid grey",
  fontSize: "14px",
  resize: "vertical",
  backgroundColor: "white",
  outline: "none",
};

export default AssessmentTable;
